import { Modal, Form, Input, InputNumber, Select, DatePicker } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
import type { ScheduleStore } from "../store";
import type { ScheduleLocation, ScheduleItemType } from "../../FestivalCalcPage/types";

interface Props {
  store: ScheduleStore;
  locations: ScheduleLocation[];
  open: boolean;
  onClose: () => void;
}

export const AddScheduleItemModal = ({ store, locations, open, onClose }: Props) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const type: ScheduleItemType = Form.useWatch("type", form);

  const handleOk = async () => {
    const values = await form.validateFields();
    setSubmitting(true);
    try {
      await store.addItem({
        type: values.type,
        title: values.title,
        startTime: (values.startTime as dayjs.Dayjs).toDate(),
        durationMinutes: values.durationMinutes,
        locationId: values.locationId,
        description: values.description ?? "",
        capacity: values.type === "workshop" ? (values.capacity ?? null) : null,
      });
      form.resetFields();
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Programmpunkt hinzufügen"
      okText="Hinzufügen"
      cancelText="Abbrechen"
      confirmLoading={submitting}
      onOk={handleOk}
      onCancel={() => { form.resetFields(); onClose(); }}
    >
      <Form form={form} layout="vertical" initialValues={{ type: "workshop", durationMinutes: 60 }}>
        <Form.Item name="type" label="Typ" rules={[{ required: true }]}>
          <Select options={[
            { value: "workshop", label: "Workshop" },
            { value: "music_act", label: "Musikact" },
          ]} />
        </Form.Item>
        <Form.Item name="title" label="Titel" rules={[{ required: true, message: "Bitte Titel eingeben" }]}>
          <Input />
        </Form.Item>
        <Form.Item name="locationId" label="Ort" rules={[{ required: true, message: "Bitte Ort auswählen" }]}>
          <Select options={locations.map((l) => ({ value: l.id.toString(), label: l.name }))} />
        </Form.Item>
        <Form.Item name="startTime" label="Beginn" rules={[{ required: true, message: "Bitte Startzeit angeben" }]}>
          <DatePicker showTime={{ format: "HH:mm" }} format="DD.MM.YYYY HH:mm" style={{ width: "100%" }} minuteStep={15} minDate={dayjs("2026-09-18", "YYYY-MM-DD")} maxDate={dayjs("2026-09-20", "YYYY-MM-DD")} />
        </Form.Item>
        <Form.Item name="durationMinutes" label="Dauer (Minuten)" rules={[{ required: true }]}>
          <InputNumber min={5} step={15} style={{ width: "100%" }} />
        </Form.Item>
        {type === "workshop" && (
          <Form.Item name="capacity" label="Kapazität (Personen)">
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
        )}
        <Form.Item name="description" label="Info">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
